import { LIGHT_THEME_KEY, lightTheme } from './light-theme/light-theme.js';

const THEMES = [LIGHT_THEME_KEY];
const themes = {
    [LIGHT_THEME_KEY]: lightTheme,
};

export { THEMES, themes };
